const HR = {
  company: [
    "društvo s ograničenom odgovornošću (d.o.o.)",
    "jednostavno društvo s ograničenom odgovornošću (j.d.o.o.)",
    "non-profit udrgua"
  ],
  legalArrangement: [
    "komanditno društvo (k.d.)",
    "udruga",
    "gospodarsko interesno udruženje"
  ],
  soleProprietorship: [
    "obrt"
  ]
};
export {
  HR as default
};
